import React, { useState, useEffect } from 'react';
/* global axios */
import api from '../services/apiService';
import { Helmet } from 'react-helmet';  // Import von React Helmet

const MachineTypeList = () => {
  const [machineTypes, setMachineTypes] = useState([]);
  const [newMachineType, setNewMachineType] = useState({ name: '', description: '', itemType: 'rental' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingMachineType, setEditingMachineType] = useState(null);

  // Maschinentypen abrufen und sortieren
  useEffect(() => {
    const fetchMachineTypes = async () => {
      try {
        const response = await api.get('/machine-types');
        const sorted = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setMachineTypes(sorted);
      } catch (err) {
        setError('Fehler beim Abrufen der Maschinentypen');
      } finally {
        setLoading(false);
      }
    };
    fetchMachineTypes();
  }, []);

  // Neuen Maschinentyp hinzufügen
  const handleAddMachineType = async () => {
    const { name, description } = newMachineType;
    if (!name) {
      alert('Bitte den Namen des Maschinentyps angeben.');
      return;
    }
    try {
      const response = await api.post('/machine-types', { name, description, itemType: 'rental' });
      const updatedList = [...machineTypes, response.data]
        .sort((a, b) => a.name.localeCompare(b.name));
      setMachineTypes(updatedList);
      setNewMachineType({ name: '', description: '', itemType: 'rental' });
    } catch (err) {
      alert('Fehler beim Hinzufügen des Maschinentyps');
    }
  };

  // Maschinentyp löschen
  const handleDeleteMachineType = async (id) => {
    if (!window.confirm('Möchten Sie diesen Maschinentyp wirklich löschen?')) return;
    try {
      await api.delete(`/machine-types/${id}`);
      setMachineTypes(machineTypes.filter(type => type.id !== id));
    } catch (err) {
      alert('Fehler beim Löschen des Maschinentyps');
    }
  };

  // Bearbeiten starten
  const handleEditClick = (type) => {
    setEditingMachineType({ id: type.id, name: type.name, description: type.description || '' });
  };

  // Bearbeitung abbrechen
  const handleCancelEdit = () => {
    setEditingMachineType(null);
  };

  // Änderungen bei Eingaben übernehmen
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditingMachineType(prev => ({ ...prev, [name]: value }));
  };

  // Speichern der Änderungen
  const handleSaveMachineType = async () => {
    const { id, name, description } = editingMachineType;
    if (!name) {
      alert('Bitte den Namen des Maschinentyps angeben.');
      return;
    }
    try {
      const response = await api.put(`/machine-types/${id}`, { name, description, itemType: 'rental' });
      const updatedList = machineTypes.map(type => type.id === id ? response.data : type)
        .sort((a, b) => a.name.localeCompare(b.name));
      setMachineTypes(updatedList);
      setEditingMachineType(null);
    } catch (err) {
      alert('Fehler beim Aktualisieren des Maschinentyps');
    }
  };

  if (loading) return <div>Lade Maschinentypen...</div>;
  if (error) return <div>{error}</div>;

  // Styles
  const buttonStyle = { fontSize: '15px', padding: '5px 10px', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', marginRight: '5px' };
  const addButtonStyle = { ...buttonStyle, background: '#28a745' };
  const editButtonStyle = { ...buttonStyle, background: '#007bff' };
  const saveButtonStyle = { ...buttonStyle, background: '#28a745' };
  const cancelButtonStyle = { ...buttonStyle, background: '#6c757d' };
  const deleteButtonStyle = { ...buttonStyle, background: '#dc3545' };

  return (
    <div>
      <Helmet>
        <title>Maschinentypen bearbeiten</title>
        <meta name="description" content="Maschinentypen bearbeiten" />
      </Helmet>
      <h2>Maschinentypen</h2>

      {/* Formular für neuen Maschinentyp */}
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '10px', marginLeft: '280px', width: '70%' }}>
        <input
          type="text"
          value={newMachineType.name}
          onChange={(e) => setNewMachineType({ ...newMachineType, name: e.target.value })}
          placeholder="Name des Maschinentyps"
        />
        <input
          type="text"
          value={newMachineType.description}
          onChange={(e) => setNewMachineType({ ...newMachineType, description: e.target.value })}
          placeholder="Beschreibung"
        />
        <button onClick={handleAddMachineType} style={addButtonStyle}>
          Hinzufügen
        </button>
      </div>

      {/* Tabelle mit Maschinentypen */}
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Beschreibung</th>
            <th>Artikelart</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {machineTypes.map(type => (
            <tr key={type.id}>
              <td>{type.id}</td>
              <td>
                {editingMachineType?.id === type.id ? (
                  <input
                    type="text"
                    name="name"
                    value={editingMachineType.name}
                    onChange={handleEditInputChange}
                  />
                ) : (
                  type.name
                )}
              </td>
              <td>
                {editingMachineType?.id === type.id ? (
                  <input
                    type="text"
                    name="description"
                    value={editingMachineType.description}
                    onChange={handleEditInputChange}
                  />
                ) : (
                  type.description || '-'
                )}
              </td>
              <td>{type.itemType}</td>
              <td>
                {editingMachineType?.id === type.id ? (
                  <>
                    <button onClick={handleSaveMachineType} style={saveButtonStyle}>Speichern</button>
                    <button onClick={handleCancelEdit} style={cancelButtonStyle}>Abbrechen</button>
                  </>
                ) : (
                  <>
                    <button onClick={() => handleEditClick(type)} style={editButtonStyle}>Bearbeiten</button>
                    <button onClick={() => handleDeleteMachineType(type.id)} style={deleteButtonStyle}>Löschen</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MachineTypeList;
